
const InputField = ({ field, formErrors, formStatus, inputChangeHandler, value, choices, show = true }) => {

	let localInputHandler = (e) => {
		inputChangeHandler && inputChangeHandler(e)
	}

	let staticLabels = {
		Requester: "Email"
	}

	if (show === false) return null

	if (["mobile_number"].includes(field.name)) {
		return (
			<>
				<label>{staticLabels[field.label_for_customers] ? staticLabels[field.label_for_customers] : field.label_for_customers}  {field.required_for_customers && <>*</>}</label>
				<input
					type="number"
					id={field.name}
					name={field.name}
					onChange={e => localInputHandler(e)}
					value={value}
					className={`form-control ${formErrors.includes(field.name) ? 'is-invalid' : ''}`}
					disabled={formStatus.submitted}
				/>
			</>
		)
	}

	if (["custom_text", "default_requester", "default_subject"].includes(field.field_type)) {

		return (
			<>
				<label>{staticLabels[field.label_for_customers] ? staticLabels[field.label_for_customers] : field.label_for_customers}  {field.required_for_customers && <>*</>}</label>
				<input
					type="text"
					id={field.name}
					name={field.name}
					// placeholder="First name"
					onChange={e => localInputHandler(e)}
					value={value}
					className={`form-control ${formErrors.includes(field.name) ? 'is-invalid' : ''}`}
					disabled={formStatus.submitted}
				/>
			</>
		)
	}

	if (["custom_number"].includes(field.field_type)) {

		return (
			<>
				<label>{staticLabels[field.label_for_customers] ? staticLabels[field.label_for_customers] : field.label_for_customers}  {field.required_for_customers && <>*</>}</label>
				<input
					type="number"
					id={field.name}
					name={field.name}
					// placeholder="First name"
					onChange={e => localInputHandler(e)}
					value={value}
					className={`form-control ${formErrors.includes(field.name) ? 'is-invalid' : ''}`}
					disabled={formStatus.submitted}
				/>
			</>
		)
	}

	if (['custom_date'].includes(field.field_type)) {

		return (
			<>
				<label htmlFor={field.name}>{staticLabels[field.label_for_customers] ? staticLabels[field.label_for_customers] : field.label_for_customers}  {field.required_for_customers && <>*</>}</label>
				<input
					type="date"
					id={field.name}
					name={field.name}
					// placeholder="First name"
					onChange={e => localInputHandler(e)}
					value={value}
					className={`form-control ${formErrors.includes(field.name) ? 'is-invalid' : ''}`}
					disabled={formStatus.submitted}
				/>
			</>
		)
	}

	if (["custom_dropdown", "nested_field"].includes(field.field_type)) {
		return (
			<>
				<label>{staticLabels[field.label_for_customers] ? staticLabels[field.label_for_customers] : field.label_for_customers}  {field.required_for_customers && <>*</>}</label>
				<select
					id={field.name}
					name={field.name}
					onChange={e => localInputHandler(e)}
					value={value}
					className={`form-control ${formErrors.includes(field.name) ? 'is-invalid' : ''}`}
					disabled={formStatus.submitted}
				>
					<option value="" key={0}> Select {staticLabels[field.label_for_customers] ? staticLabels[field.label_for_customers] : field.label_for_customers} </option>
					{choices ?
						choices.map(choice => <option value={choice.value} key={choice.id}> {choice.value} </option>)
						:
						field.hasOwnProperty('choices') && field.choices.map(choice => <option value={choice.value} key={choice.id}> {choice.value} </option>)
					}
				</select>
			</>
		)
	}

	if (["custom_content", "default_description", "custom_paragraph"].includes(field.field_type)) {
		return (
			<>
				<label>{staticLabels[field.label_for_customers] ? staticLabels[field.label_for_customers] : field.label_for_customers}  {field.required_for_customers && <>*</>}</label>
				<textarea
					type="text"
					id={field.name}
					name={field.name}
					// placeholder="First name"
					rows={12}
					onChange={e => localInputHandler(e)}
					value={value}
					className={`form-control ${formErrors.includes(field.name) ? 'is-invalid' : ''}`}
					disabled={formStatus.submitted}
				></textarea>
			</>
		)
	}

	return <></>
}

export default InputField;